import {
  Maybe, OrderPaymentCallbackPayload,
  OrderStatusId,
  PaymentOperation,
  PaymentStatus,
} from "@phonero/common-graphql/types"
import React from "react"
import { useAppTranslations } from "@phonero/common-ux"
import { useAppRouterDP } from "../../../util/useAppRouterDP"
import css from "./PaymentCallback.module.scss"
import { PuxHugeIcon } from "./HugeIcon"
import { PuxButton } from "@phonero/pux-react"

type ErrorType = NonNullable<
  OrderPaymentCallbackPayload["errors"]
>[0]["__typename"]

export const VippsPaymentOrderStatusText = ({
  paymentStatus,
  orderStatus, // = OrderStatusId.Registered,
  productText, // = "Super abo",
  productID: productId,
  error,
  orderMessage,
  errorType,
  receipt,
  amount,
}: {
  paymentStatus: PaymentOperation | undefined
  amount: Maybe<number> | undefined
  orderStatus: OrderStatusId | undefined
  orderMessage: string | null | undefined
  productText: Maybe<string> | undefined
  productID: Maybe<string | number> | undefined
  error?: React.ReactNode
  errorType?: ErrorType
  receipt?: Maybe<{
    contractProductId: Maybe<string | number>
    status: PaymentStatus
  }>
}) => {
  const { t } = useAppTranslations()
  const { goTo, dialogues, paths } = useAppRouterDP()
  const tOptions = {
    context:
      orderStatus === OrderStatusId.Cancelled ||
      orderStatus === OrderStatusId.Completed
        ? orderStatus
        : paymentStatus || "loading",
    mdInline: false,
    orderStatus,
    paymentStatus,
    productText,
    amount,
  }
  const statusText = t("PaymentCallBack.Status", tOptions)
  const paymentStatusTxt =
    !!paymentStatus &&
    t("PaymentCallBack.PaymentStatus", {
      context: paymentStatus,
      orderStatus,
      paymentStatus,
      amount,
      postProcess: "no",
    })
  // OrderPaymentCallbackPayload
  const orderStatusTxt = t("PaymentCallBack.OrderStatus", {
    context: orderStatus || "UNKNOWN",
    orderStatus,
    orderMessage,
    paymentStatus,
    amount,
    postProcess: "no",
  })
  return (
    <div style={{ paddingBlockStart: 30 }} className={css.container}>
      <div>
        {orderStatus === OrderStatusId.Completed ? (
          <PuxHugeIcon state="success" />
        ) : paymentStatus === PaymentOperation.Cancelled ? (
          <PuxHugeIcon state="cancelled" />
        ) : orderStatus === OrderStatusId.Cancelled || !!error ? (
          <PuxHugeIcon state="error" />
        ) : (
          paymentStatus !== PaymentOperation.Initate && (
            <PuxHugeIcon state="loading" />
          )
        )}
        {!!error ? (
          <div>
            {t("PaymentCallBack.Error", {
              context: errorType,
              error,
              productText,
              orderStatus,
              paymentStatus,
              paymentStatusTxt,
              orderStatusTxt,
              mdInline: false,
            })}
            {orderMessage}
          </div>
        ) : (
          <div>
            {statusText}
            {!!productText && t("PaymentCallBack.ProductText", tOptions)}
            {orderMessage}
          </div>
        )}
      </div>
      <div className={css.buttons}>
        {!!receipt?.contractProductId && (
          <PuxButton
            href={paths.myReceipts(String(receipt.contractProductId || ""))}
            className="btn-mw"
            color="medium"
            onClick={(e) => {
              e.preventDefault()
              goTo("paymentCallback-receipt", null, {
                orderId: receipt.contractProductId,
              }).receipt()
            }}
          >
            {t("PaymentCallBack.GoToReceipt", {
              ...receipt,
              context: receipt.status,
              orderStatus,
              paymentStatus,
              amount,
            })}
          </PuxButton>
        )}
        {paymentStatus === PaymentOperation.Cancelled ? (
          <>
            {productId && (
              <PuxButton
                href={paths.home()}
                className="btn-mw"
                onClick={(e) => {
                  e.preventDefault()
                  dialogues.data("paymentCallback-home")(
                    productId ? { productId: String(productId) } : undefined
                  )
                }}
              >
                {t("PaymentCallBack.TryAgain", {
                  ...receipt,
                  context: orderStatus || paymentStatus,
                  orderStatus,
                  paymentStatus,
                  amount,
                  productText,
                })}
              </PuxButton>
            )}
          </>
        ) : paymentStatus === PaymentOperation.Captured ||
          orderStatus === OrderStatusId.Completed ? (
          <PuxButton
            className="btn-mw"
            onClick={() => goTo("paymentCallback").home()}
          >
            {t("PaymentCallBack.GoToHome")}
          </PuxButton>
        ) : null}
      </div>
    </div>
  )
}